<!--<div class="row">
  <div class="column">
    <div class="cardright">
      <h3 class="card-title">Top Ratings</h3>
      <button class="btn">See all</button>

      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th class="th1">Name</th>
              <th class="th2">Profile code</th>
              <th class="th3">Rating</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="column">
    <div class="card2">
      <h3 class="card-title2">Clubs you may like</h3>
      <button class="btn2">See all</button>

      <div class="table-container">
        <table>
          <tbody>
            <tr></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>-->
<div class="score_component">
    <div class="first_part">
      <div class="title">Top Score</div>
      <button class="btn">See all</button>
    </div>
    <div class="second_part">
      <table class="tab">
        <tr>
          <th class="th">Club name</th>
        
          <th class="th">score</th>
        </tr>
        <tr *ngFor="let club of listClub; let i; of: index">
          <td class="td">
            <img class="profile-photo" src="http://localhost:9091/User/{{ club.profileImage }}">
            {{club.titre}}</td>
          
          <td class="th">{{club.score}}</td>
        </tr>
     
      </table>
   
    </div>
  </div>
  <div class="right-component">
    <div class="first-part">
      <div class="title">Clubs you may like</div>
      <button class="btn">see all</button>
    </div>
    <div class="first" *ngFor="let item of listClub">
      <img
        [src]="'http://localhost:9091/User/' + item.profileImage"
        [alt]="item.name"
        style="width: 30%; height: 25%; border-radius: 10%"
      />
  
      <div class="text">
        <div class="clubname" style="color: #1b2559">{{ item.titre }}</div>
        <div class="description">{{ item.titre }}</div>
      </div>
    </div>
  </div>